import { Component, Input, OnInit } from '@angular/core';
import { NavigationService } from '@app/finxone-web-frontend/app/lib/services/navigation-service/navigation.service';
import { RoleState, RoleStateModel } from '@app/finxone-web-frontend/app/lib/state/role.state';
import { AutoDestroy } from '@finxone-platform/shared/base-types';
import {
  SwitchNavigatorQuickLinkWidgetConfig,
  baseCssConfigStyle,
} from '@finxone-platform/shared/sys-config-types';
import { Select } from '@ngxs/store';
import { Observable, Subject, takeUntil } from 'rxjs';
import { ZonePageUrlProvider } from '../../../zones/zone-url-provider';

@Component({
  standalone: false,
  selector: 'finxone-web-frontend-switch-navigator-quick-link',
  templateUrl: './switch-navigator-quick-link.component.html',
  styleUrls: ['./switch-navigator-quick-link.component.scss'],
})
export class SwitchNavigatorQuickLinkComponent implements OnInit {
  @AutoDestroy private destroy$: Subject<void> = new Subject<void>();
  @Input() public widgetData = {} as SwitchNavigatorQuickLinkWidgetConfig;
  @Input() public pageUrlsData: {
    role: string;
    zone: string;
    pageUrl: string;
    isActive: boolean;
    pageId?: string;
  }[] = [];

  @Input() public activeSwitchStyle: baseCssConfigStyle;
  @Input() public contentStyle: baseCssConfigStyle;
  @Input() public marginBorderStyle: baseCssConfigStyle;

  @Select(RoleState.getRole)
  roles!: Observable<RoleStateModel>;
  roleInfo: RoleStateModel;

  constructor(
    private zonePageUrlProvider: ZonePageUrlProvider,
    private navigationService: NavigationService,
  ) {
    this.roles.pipe(takeUntil(this.destroy$)).subscribe((roles) => {
      this.roleInfo = roles;
    });
  }

  ngOnInit() {
    this.isActivePage();
  }

  public redirectToPage(pageData: { role: string; zone: string; pageUrl: string; isActive: boolean }) {
    this.navigationService.navigateByPageUrl({
      url: pageData.pageUrl,
      targetRole: pageData?.role,
      currentRole: this.roleInfo.role,
      zone: pageData.zone,
    });
  }

  private isActivePage() {
    this.pageUrlsData.forEach((page, index) => {
      const splitPageUrl = page.pageUrl.split('/');
      if (splitPageUrl[splitPageUrl.length - 1] === this.zonePageUrlProvider.pageUrlInput) {
        this.pageUrlsData[index].isActive = true;
      } else {
        this.pageUrlsData[index].isActive = false;
      }
    });
  }
}
